<template>
  <div class="footer">
    <div class="footer-content">
      <div class="info">
        <p>电话：15315145064</p>
        <p>地址：浙江省杭州市余杭区良渚街道金家渡路112号4号楼134室</p>
      </div>
      <div class="qrBox q1">
        <img :src="qrArr[0].img" />
        <p class="p1">{{qrArr[0].name}}</p>
      </div>
      <div class="qrBox q2">
        <img :src="qrArr[1].img" />
        <p class="p1">{{qrArr[1].name}}</p>
      </div>
      <div class="footer-copyright">
        <a
          class="copyright"
          target="_blank"
          href="https://beian.miit.gov.cn/"
        >
          <img src="/static/img/footer/beian.png" />
          <span>浙公网安备33010202001899号浙ICP备2023042247号-1</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myFooter',
  data () {
    return {
      qrArr: [
        {
          name: '微信公众号',
          img: '/static/img/footer/wechat.jpg'
        },
        {
          name: 'APP下载',
          img: '/static/img/footer/all.jpg'
        }
      ]
    }
  },
  methods: {
    toPage (path) {
      this.$router.push({ path: path })
      document.documentElement.scrollTop = document.body.scrollTop = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
.footer {
  width: 100%;
  min-width: 1200px;
  text-align: center;
  color: #f5f5f5;
  overflow: hidden;
  height: 383px;
  background: url("/static/img/footer/footer-bg.jpg") no-repeat;
  background-size: 100% 100%;
  .footer-content {
    width: 1200px;
    height: 383px;
    display: inline-block;
    font-size: 0;
    position: relative;
    .info {
      display: inline-block;
      color: #bfcbd9;
      vertical-align: top;
      text-align: left;
      position: absolute;
      left: 0;
      top: 80px;
      p {
        font-family: SourceHanSansSC-Regular;
        font-size: 18px;
        line-height: 32px;
        color: #ffffff;
        cursor: default;
        margin-bottom: 25px;
      }
    }
    .qrBox {
      text-align: center;
      display: inline-block;
      position: absolute;
      top: 80px;
      .p1 {
        font-size: 18px;
        line-height: 32px;
        color: #ffffff;
        cursor: default;
        margin-top: 10px;
      }
      img {
        width: 100px;
        height: 100px;
      }
    }
    .q1 {
      right: 248px;
    }
    .q2 {
      right: 106px;
    }
    .footer-copyright {
      padding-top: 24px;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 10px;
      border-top: 1px solid rgba(255, 255, 255, .7);
      .copyright {
        display: block;
        font-size: 18px;
        font-family: SourceHanSansSC-Regular;
        letter-spacing: 2.33px;
        color: #fff;
        line-height: 25px;
        margin-bottom: 8px;
        text-align: left;
      }
      p {
        cursor: default;
      }
      span {
        display: inline-block;
        vertical-align: middle;
      }
      img {
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }
      a {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myFooter.vue